import { Outlet, useLocation } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { TopBar } from '@/components/layout/TopBar';
import { AccountCurrencyProvider } from '@/contexts/AccountCurrencyContext';
import { AppDateRangeProvider } from '@/contexts/AppDateRangeContext';
import { isWorkspaceShellPath } from '@/api/workspaceScope';

export function AppLayout() {
  const location = useLocation();
  const showSidebar = isWorkspaceShellPath(location.pathname);

  return (
    <AppDateRangeProvider>
      <AccountCurrencyProvider>
      {showSidebar ? (
        <AppShell>
          <Outlet />
        </AppShell>
      ) : (
        <div className="min-h-screen bg-page">
          <main className="min-h-screen">
            <Outlet />
          </main>
        </div>
      )}
      </AccountCurrencyProvider>
    </AppDateRangeProvider>
  );
}

/** Authenticated chrome for unmatched routes: existing TopBar, no campaign sidebar. */
export function NotFoundLayout() {
  return (
    <AppDateRangeProvider>
      <div className="flex min-h-screen flex-col bg-page">
        <div className="shrink-0 border-b border-border bg-surface">
          <TopBar />
        </div>
        <main className="flex flex-1 items-center justify-center px-4 py-10 sm:px-6 lg:px-8">
          <Outlet />
        </main>
      </div>
    </AppDateRangeProvider>
  );
}
